import { FormControl, FormArray, FormGroup } from '@angular/forms';
export interface ICommissionInfo {
  ComissionId: string;
  Code: number;
  Bank: string;
  Company: string;
  Period: string;
  CommissionType: number;
  MaxCommissionPerContract?: number;
  Products: string;
  ProductsInfos: IProductInfo[];
}

export interface IProductInfo {
  Name: string;
  Infos: {
    Percentage?: number;
    InvoiceValue?: number;
    TransferValue?: number;
  }[];
}

export interface ICommission {
  ComissionId?: string | null;
  Code: number;
  ProductsComission: IProduct[];
}

export interface IProduct {
  ProductComissionId?: string;
  ComissionId?: string;
  BankId: string;
  ProductId: string;
  CompanyId: string;
  Period: string;
  CommissionType: number;
  MaxCommissionPerContract?: number;
  Productions: IProduction[];
}

export interface IProduction {
  ProductionID?: string;
  InitialProduction: number;
  FinalProduction: number;
  Percentage?: number;
  InvoiceValue?: number;
  TransferValue?: number;
}

export interface IProductForm {
  ProductComissionId: FormControl<string>;
  ComissionId: FormControl<string>;
  BankId: FormControl<string>;
  ProductId: FormControl<string>;
  CompanyId: FormControl<string>;
  Period: FormControl<string>;
  CommissionType: FormControl<number>;
  MaxCommissionPerContract: FormControl<number | null>;
  Productions: FormArray<FormGroup<IProductionForm>>;
}

export interface IProductionForm {
  ProductionID: FormControl<string>;
  InitialProduction: FormControl<number>;
  FinalProduction: FormControl<number>;
  Percentage: FormControl<number>;
  InvoiceValue: FormControl<number>;
  TransferValue: FormControl<number>;
}

export interface IBankCommission {
  BankId: string;
  Name: string;
}

export interface IProductCommission {
  ProductId: string;
  Name: string;
}

export interface ICompanyCommission {
  CompanyId: string;
  Name: string;
}

export interface ISearchFilterCommission {
  Banks: IBankCommission[];
  Periods: string[];
  Products: IProductCommission[];
  Text: string;
  Skip: number;
  Take: number;
}

export interface IFilterModalCommission {
  Banks: IBankCommission[];
  Periods: string[];
  Products: IProductCommission[];
}

export interface IProductionField {
  label: string;
  controlName: string;
  value: string | number | null;
  currencyMask: boolean;
}

export interface IParametersCommission {
  Banks: IBankCommission[];
  ProductsName: IProductCommission[];
  Enterprises: ICompanyCommission[];
}

export interface ICommissionForm {
  ComissionId: string;
  Code?: number;
  Products: any;
}

export interface IProductValues {
  BankId: string;
  CompanyId: string;
  Period: string;
  CommissionType: number;
  MaxCommissionPerContract?: number;
}

export enum ProductTabEnum {
  Produto = 'produto',
  NovoProduto = 'novo-produto'
}
